import type { UseFormGetValues, UseFormSetValue } from 'react-hook-form';

import type { RiderFormValues } from '../types';

/**
 * Removes the Car Seat ('CS') service from `services` when it's present, marking the field
 * dirty. No-op when `services` doesn't include `'CS'`. Shared by every site that resolves a
 * Car Seat / Booster Seat conflict in favor of Booster Seat — manual toggling
 * (`SeatOptionsSubsection`) and the age-based auto-check (`useBoosterSeatAutoCheck`).
 */
export const removeCarSeatFromServices = (
  getValues: UseFormGetValues<RiderFormValues>,
  setValue: UseFormSetValue<RiderFormValues>
): void => {
  const currentServices = getValues('services') ?? [];

  if (currentServices.includes('CS')) {
    setValue(
      'services',
      currentServices.filter((code) => code !== 'CS'),
      { shouldDirty: true }
    );
  }
};
